import React, { useState } from 'react';
import MenuTH from './MenuTH';
import MenuENG from './MenuENG';
import Campaign from './Campaign';
import Calendar from './Calendar';
import ServicesArtwork from './ServicesArtwork';
import PackageArtwork from './PackageArtwork';
import ServicesReview from './ServicesReview';
import MsgShortcut from './MsgShortcut'; // ✅ เพิ่มไฟล์ใหม่
import RefineryInsider from './Insider'; // ✅ เพิ่มไฟล์ใหม่

export default function SendMediaDrawer({ onClose, selectedUserId, selectedCustomer, onSendImage }) {
  const [selectedSection, setSelectedSection] = useState(null);
  const [selectedSAItem, setSelectedSAItem] = useState(null);
  const [selectedUltraOption, setSelectedUltraOption] = useState(null); // 'Membership' หรือ 'Standard'

  return (
    <div className="w-full h-full flex flex-col max-w-screen-xl mx-auto">
      {/* Header */}
      <div className="flex justify-between items-center px-4 py-3 border-b">
        <h2 className="text-xl font-bold ml-2">Refinery Asset</h2>
        <button
          onClick={onClose}
          className="text-sm text-gray-500 hover:text-gray-700 mr-4"
        >
          Close
        </button>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-4">
        {!selectedSection && (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {[
              { label: 'Shortcut', icon: '𝗦𝗖', key: 'shortcut' }, // ✅ ปุ่มใหม่
              { label: 'Refinery Menu (Thai)', icon: '𝗧𝗛', key: 'th' },
              { label: 'Refinery Menu (Eng)', icon: '𝗘𝗡𝗚', key: 'en' },
              { label: 'Campaign', icon: '𝗖𝗔', key: 'campaign' },
              { label: 'Services Artwork', icon: '𝗦𝗔', key: 'sa' },
              { label: 'Set Package Artwork', icon: '𝗦𝗣', key: 'pa' },
              { label: 'Services Review', icon: '𝗦𝗥', key: 'sr' },
              { label: "Doctor's Calendar", icon: '𝗗𝗖', key: 'calendar' },
              { label: "Refinery Insider", icon: '𝗥𝗜', key: 'insider' },
            ].map((item, index) => (
              <div
                key={index}
                className="flex flex-col items-center justify-center border rounded-xl p-4 cursor-pointer hover:shadow-md transition"
                onClick={() => setSelectedSection(item.key)}
              >
                <div className="text-3xl mb-2">{item.icon}</div>
                <div className="text-center text-sm font-medium">{item.label}</div>
              </div>
            ))}
          </div>
        )}

        {selectedSection === 'shortcut' && (
          <MsgShortcut
            onBack={() => setSelectedSection(null)}
            onSendImage={onSendImage}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={selectedUserId}
          />
        )}

        {selectedSection === 'pa' && (
          <PackageArtwork
            onBack={() => setSelectedSection(null)}
            onSendImage={onSendImage}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={selectedUserId}
          />
        )}

        {selectedSection === 'th' && (
          <MenuTH
            onBack={() => setSelectedSection(null)}
            onSendImage={onSendImage}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={selectedUserId}
          />
        )}
        {selectedSection === 'en' && (
          <MenuENG
            onBack={() => setSelectedSection(null)}
            onSendImage={onSendImage}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={selectedUserId}
          />
        )}
        {selectedSection === 'campaign' && (
          <Campaign
            onBack={() => setSelectedSection(null)}
            onSendImage={onSendImage}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={selectedUserId}
          />
        )}
        {selectedSection === 'calendar' && (
          <Calendar
            onBack={() => setSelectedSection(null)}
            onSendImage={onSendImage}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={selectedUserId}
          />
        )}
        {selectedSection === 'sa' && (
          <ServicesArtwork
            onBack={() => setSelectedSection(null)}
            selectedUserId={selectedUserId}
            selectedSAItem={selectedSAItem}
            setSelectedSAItem={setSelectedSAItem}
            selectedUltraOption={selectedUltraOption}
            setSelectedUltraOption={setSelectedUltraOption}
            onSendImage={onSendImage}
            selectedCustomer={selectedCustomer}
            userId={selectedUserId}
          />
        )}
        {selectedSection === 'sr' && (
          <ServicesReview
            onBack={() => setSelectedSection(null)}
            onSendImage={onSendImage}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={selectedUserId}
          />
        )}
        {selectedSection === 'insider' && (
          <RefineryInsider
            onBack={() => setSelectedSection(null)}
            onSendImage={onSendImage}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={selectedUserId}
          />
        )}
      </div>
    </div>
  );
}
